import React from 'react';
import { Link } from 'react-router-dom';
import { Home, AlertCircle } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 text-center">
        <div className="flex justify-center">
          <AlertCircle className="h-24 w-24 text-[#8cc63f]" />
        </div>
        <div>
          <h1 className="text-9xl font-extrabold text-[#4a3f35]">404</h1>
          <h2 className="mt-4 text-3xl font-bold text-gray-900">Page Not Found</h2>
          <p className="mt-2 text-lg text-gray-600">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>
        <div className="mt-8">
          <Link
            to="/calendar"
            className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-[#8cc63f] hover:bg-[#7ab32e] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#8cc63f]"
          >
            <Home className="h-5 w-5 mr-2" />
            Back to Calendar
          </Link>
        </div>
      </div>
    </div>
  );
}
